var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEyesGlow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 92,
    height: 41,
    viewBox: "0 0 92 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_293_835)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M79.5441 16.6612C80.4477 21.8543 75.7806 27.0036 69.12 28.1625C62.4593 29.3214 56.3273 26.051 55.4238 20.858C54.5202 15.6649 58.3786 14.2831 65.0393 13.1242C71.6999 11.9653 78.6406 11.4682 79.5441 16.6612Z",
    fill: "#0CC5FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5938 16.6612C11.6903 21.8543 16.3573 27.0036 23.018 28.1625C29.6786 29.3214 35.8106 26.051 36.7142 20.858C37.6177 15.6649 33.7593 14.2831 27.0987 13.1242C20.438 11.9653 13.4974 11.4682 12.5938 16.6612Z",
    fill: "#0CC5FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_293_835",
    x: 0.481934,
    y: 0.364227,
    width: 91.1743,
    height: 40.0316,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0470588 0 0 0 0 0.772549 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_293_835"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_293_835",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyesGlow);
export default __webpack_public_path__ + "static/media/eyes-glow.3b8d48daf72cd8ac105b17cad2ff2723.svg";
export { ForwardRef as ReactComponent };